module.exports = __webpack_public_path__ + "static/media/signout.3676cf9c.svg";